export default "__VITE_ASSET__BXAF4uAz__"